import { cloneElement, forwardRef, MouseEvent, ReactElement, useRef } from "react";
import { GridRowProps } from "@progress/kendo-react-grid";
import useOuterClick from "./UseOuterClick.js";
import { handleOuterClick } from "./HandleOuterClick";

export interface RenderProps {
  originalProps: GridRowProps;
  tr: ReactElement<HTMLTableRowElement>;
}

export interface InlineEditExitProps {
  editField: string | undefined;
  exitEdit: (dataItem: any) => void;
}

export type InlineEditRowRenderProps = RenderProps & InlineEditExitProps;

export const InlineEditRowRender = forwardRef((props: InlineEditRowRenderProps, ref) => {
  const innerRef = useRef(ref);

  useOuterClick(innerRef, (e: MouseEvent<HTMLElement>, tr: HTMLTableRowElement) => {
    handleOuterClick(e, tr, props.exitEdit, props.originalProps.dataItem);
  });

  const innerRefProp = { ref: innerRef };
  return cloneElement(
    props.tr,
    {
      ...props.tr.props,
      ...innerRefProp,
    },
    props.tr.props.children
  );
});
